import { FOCUS_LABELS, type FocusArea } from "@coaching/types";

/** What the player asked for help with, as chips. Nothing for a submission made before focus areas existed. */
export function FocusChips({ areas, prefix }: { areas: FocusArea[] | undefined; prefix?: string }) {
    if (!areas || areas.length === 0) return null;
    return (
        <div className="focus-chips" aria-label={prefix ? `${prefix}: ${areas.map((a) => FOCUS_LABELS[a]).join(", ")}` : undefined}>
            {prefix && <span className="focus-prefix">{prefix}</span>}
            {areas.map((a) => <span key={a} className="pill">{FOCUS_LABELS[a]}</span>)}
        </div>
    );
}
